import React from 'react';
import muiThemeable from 'material-ui/styles/muiThemeable';
import FlatButton from "material-ui/FlatButton";
import Dialog from 'material-ui/Dialog';
import { ValidatorForm } from "react-form-validator-core";
import { TextValidator } from "react-material-ui-form-validator";

import { AddIsJsonValidation } from '../../../helpers/JobHelpers';

class SettingsDialog extends React.Component {
    constructor(props) {
        super(props);

        this.state = { job: null };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleClose = this.handleClose.bind(this);
    }

    componentWillMount() {
        AddIsJsonValidation(ValidatorForm);
    }

    handleChange(event) {
        this.setState({ [event.target.name]: event.target.value });
    }

    handleSubmit(event) {
        let { job } = this.state;

        let returnJob = this.props.job;

        if (job) {
            try {
                returnJob = JSON.parse(job);
            }
            catch (e) {}
        }

        this.setState({ job: null });
        
        this.props.handleSubmit(returnJob);
    }

    handleClose(event) {
        this.setState({ job: null });

        this.props.handleSettingsDialogClose();
    }

    render() {
        let job = this.state.job || JSON.stringify(this.props.job, null, 2);

        let isJobValid;

        try {
            isJobValid = JSON.parse(job);
        }
        catch (e) { 
            isJobValid = false;
        }

        const actions = [
            <FlatButton
                label="Cancelar"
                primary={true}
                onClick={this.handleClose}
            />,
            <FlatButton
                label="Confirmar"
                disabled={!isJobValid}
                primary={true}
                keyboardFocused={true}
                onClick={this.handleSubmit}
            />
        ];

        return (
            <Dialog
                title="Parâmetros da tarefa"
                titleStyle={{background: this.props.muiTheme.palette.primary1Color}}
                actions={actions}
                modal={false}
                open={this.props.open}
                onRequestClose={this.handleClose}
            >
                <ValidatorForm onSubmit={this.handleSubmit}>
                    <TextValidator
                        name="job"
                        value={job}
                        validators={["isJson"]}
                        errorMessages={["Deve conter formato JSON"]}
                        onChange={this.handleChange}
                        autoComplete="off"
                        fullWidth multiLine
                    />
                </ValidatorForm>

                <div style={{ fontSize: 12, display: "flex", flexFlow: "row-reverse" }}>

                    <a style={{ textDecoration: "none", margin: '14px 0 0 12px', color: this.props.muiTheme.palette.primary1Color }}
                        href="https://apscheduler.readthedocs.io/en/v2.1.2/cronschedule.html"
                        rel="noopener noreferrer" target="_blank" >&raquo; Cron-style</a>

                    <a style={{ textDecoration: "none", margin: '14px 0 0 0', color: this.props.muiTheme.palette.primary1Color }}
                        href="https://apscheduler.readthedocs.io/en/latest/modules/schedulers/base.html#apscheduler.schedulers.base.BaseScheduler.add_job"
                        rel="noopener noreferrer" target="_blank" >&raquo; Job</a>

                </div>
            </Dialog>
        );
    }
}

export default muiThemeable()(SettingsDialog)


// WEBPACK FOOTER //
// ./src/components/view/scheduler/job/SettingsDialog.js